export default __webpack_public_path__ + "static/social media 2-911838e21272d4e25cab6a4b3b729bf7.webp";